import { ColorStyleType } from '@lib/types'

import styles from './component-link.module.scss'

export const getLinkColorClassName = (colorStyle?: ColorStyleType) => {
  switch (colorStyle) {
    case ColorStyleType.Black:
      return styles.blackLink
    default:
    case ColorStyleType.Default:
      return null
  }
}
